import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import SectionHeader from '../components/common/SectionHeader';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';
import NewsCard from '../components/common/NewsCard';
import TerritoryStrip from '../components/common/TerritoryStrip';

const NotiziePage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Notizie' }];

  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Hub Editoriale" title="Notizie" subtitle="Le notizie dall'Italia, dal territorio e dall'organizzazione. Aggiornamenti, approfondimenti e storie." />

      <section className="section section--sm">
        <div className="container">
          <Toolbar
            className="mb-8"
            left={<SearchBar placeholder="Cerca nelle notizie..." ariaLabel="Cerca notizie" />}
            right={<>
              <FilterSelect label="Regione" options={['Tutte', 'Lombardia', 'Lazio', 'Toscana', 'Emilia-Romagna', 'Campania']} />
              <FilterSelect label="Tema" options={['Tutti', 'Lavoro', 'Istruzione', 'Ambiente', 'Diritti']} />
              <FilterSelect label="Livello" options={['Tutti', 'Nazionale', 'Regionale', 'Provinciale', 'Locale']} />
            </>}
          />

          {/* Hero news */}
          <NewsCard 
            variant="hero" 
            title='Assemblea Nazionale GD: approvato il documento politico "L&apos;Italia che vogliamo"' 
            excerpt="L'Assemblea Nazionale dei Giovani Democratici ha approvato all'unanimità il nuovo documento programmatico che definisce le priorità politiche dell'organizzazione per il prossimo biennio." 
            badge="In Evidenza" 
            meta={['15 Marzo 2026', '5 min']} 
            tags={[{ label: 'Assemblea', primary: true }, { label: 'Documento Politico' }]} 
            image="https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop"
          />

          {/* In evidenza */}
          <SectionHeader overline="In Evidenza" className="mb-6 mt-10" />
          <div className="grid grid-3 mb-12">
            <NewsCard title="Tavola rotonda sul diritto allo studio universitario" badge="Lazio" meta={['12 Mar 2026']} excerpt="Confronto aperto a Roma sul futuro dell'università pubblica." image="https://images.unsplash.com/photo-1523050853051-f7500248a13f?q=80&w=800&auto=format&fit=crop" />
            <NewsCard title='Firenze, "Abitare Giovane": 500 firme in una settimana' badge="Toscana" meta={['10 Mar 2026']} excerpt="Grande partecipazione alla raccolta firme regionale." image="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop" />
            <NewsCard title="8 Marzo: le proposte per la parità di genere" badge="Nazionale" meta={['8 Mar 2026']} excerpt="Proposte concrete per il gender pay gap e l'occupazione giovanile." image="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=800&auto=format&fit=crop" />
          </div>

          {/* Dal territorio */}
          <SectionHeader overline="Dal Territorio" className="mb-4" />
          <TerritoryStrip items={['Tutte', 'Lombardia', 'Lazio', 'Toscana', 'Campania', 'Sicilia', 'Piemonte']} className="mb-6" />
          <div className="grid grid-3 mb-12">
            {[
              { title: 'GD Milano: incontro con i candidati', badge: 'Milano', date: '14 Mar', image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=800&auto=format&fit=crop' },
              { title: 'Campania: assemblea regionale', badge: 'Napoli', date: '13 Mar', image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=800&auto=format&fit=crop' },
              { title: 'Piemonte: scuola di formazione', badge: 'Torino', date: '11 Mar', image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=800&auto=format&fit=crop' },
              { title: 'Flash mob per il clima in piazza', badge: 'Bologna', date: '10 Mar', image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=800&auto=format&fit=crop' },
              { title: 'Rapporto sulla condizione giovanile', badge: 'Palermo', date: '9 Mar', image: 'https://images.unsplash.com/photo-1529156069898-49953eb1b5ae?q=80&w=800&auto=format&fit=crop' },
              { title: '"Scuola Aperta" nelle periferie', badge: 'Bari', date: '8 Mar', image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?q=80&w=800&auto=format&fit=crop' },
            ].map((n) => (
              <NewsCard key={n.title} variant="compact" title={n.title} badge={n.badge} meta={[n.date]} image={n.image} />
            ))}
          </div>

          {/* Ultime notizie */}
          <SectionHeader overline="Ultime Notizie" className="mb-6" />
          <div className="grid grid-3">
            {[
              { title: 'GD e PD insieme: dichiarazione congiunta sul lavoro giovanile', meta: ['Nazionale', '7 Mar 2026'], img: 'https://images.unsplash.com/photo-1521737703345-d4a1936365ea?q=80&w=800&auto=format&fit=crop' },
              { title: 'GD Lombardia: presentata la mozione sul trasporto pubblico', meta: ['Lombardia', '5 Mar 2026'], img: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=800&auto=format&fit=crop' },
              { title: "Catania, volontariato nelle scuole: grande successo dell'iniziativa", meta: ['Sicilia', '3 Mar 2026'], img: 'https://images.unsplash.com/photo-1559027615-cd9673980d52?q=80&w=800&auto=format&fit=crop' },
              { title: 'Padova, confronto aperto sulla transizione ecologica', meta: ['Veneto', '1 Mar 2026'], img: 'https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?q=80&w=800&auto=format&fit=crop' },
              { title: 'Report: il contributo dei GD alle elezioni amministrative 2025', meta: ['Nazionale', '28 Feb 2026'], img: 'https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?q=80&w=800&auto=format&fit=crop' },
              { title: 'Lecce: inaugurato il nuovo circolo GD "Ferruccio Ferrara"', meta: ['Puglia', '25 Feb 2026'], img: 'https://images.unsplash.com/photo-1517457373958-b7bdd058a548?q=80&w=800&auto=format&fit=crop' },
            ].map((n) => (
              <NewsCard key={n.title} title={n.title} meta={n.meta} image={n.img} />
            ))}
          </div>

          {/* Tags */}
          <div className="mt-12 mb-8">
            <h3 className="h5 mb-4">Temi principali</h3>
            <div className="tags">
              {['Lavoro', 'Istruzione', 'Ambiente', 'Diritti'].map((t) => (
                <span className="tag" key={t}>{t}</span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotiziePage;
